var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialMedia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-167"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.25,173.69H342.11s11.12-30.37,28.23-30.37,22.47,21,22.47,21,11.55-11.38,21-11.38,17.73,15,17.73,15S445,159.85,454.25,173.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.48,68.77h-52.4s11.71-17,20.93-17S372,63.12,372,63.12s6.51-5.28,12.55-4.34S391.48,68.77,391.48,68.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.79,285.56H97.38s11.71-17,20.94-17,12,11.31,12,11.31,6.51-5.28,12.54-4.34S149.79,285.56,149.79,285.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.83,164.65H45.75s14-31.21,28.94-33.16,22.1,23.19,22.1,23.19,9.65-8.89,17.23-8.89,13.44,11.7,13.44,11.7S142.63,149.48,147.83,164.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.58,87.44h-69s11.85-22.61,24.7-22.94,19.6,17.12,19.6,17.12S214.91,65.58,219.58,87.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.73,303.64h-69S326.62,281,339.47,280.7s19.6,17.11,19.6,17.11S379.06,281.77,383.73,303.64Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-167"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 453.14,
    rx: 129.16,
    ry: 13.85,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-167"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.1,364.43c-5,.18-10.59.46-14.74-2.79-3.83-3-7.24-7.46-6.74-12.59.15-1.46.48-2.37,2-1.74,2.39.95,4.23,3.58,5.88,5.43a51,51,0,0,0,6.95,6.59c1.78,1.37,3.7,2.55,5.52,3.87.23.16.46.33.68.51l.26.19h.14a.27.27,0,0,1,.21.11.32.32,0,0,1,0,.09A.26.26,0,0,1,177.1,364.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,364.1c-4.4-.08-9.15.12-12.67-2.87a20.35,20.35,0,0,1-4.09-5c-.5-.83-2-3.3-1.4-4.28,1.15-1.78,6.39,5.47,7.12,6.16A21.45,21.45,0,0,0,176,363.2c.23.16.46.33.68.51a23.93,23.93,0,0,1-7.3-2.81c-3.12-1.86-4.86-4.62-7.31-7.19-.52-.56-2.12-2.43-2.72-1.26-.39.77,1.08,3.18,1.4,3.7a20.41,20.41,0,0,0,3.86,4.72c3.51,3.07,8.24,3,12.68,3.14A.32.32,0,0,1,177.34,364.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.86,367.48l-.12.58v0a.13.13,0,0,1-.09.1.21.21,0,0,1-.26-.1.13.13,0,0,1,0-.12.31.31,0,0,1,0-.08l.06-.17h0s0,0,0-.06c-.89-3.31-1.23-6.76-2.17-10.07s-2-6.27-2.64-9.5c-.41-2-1.82-12.25,2.68-11,2,.57,3.36,3.46,4.12,5.18a21.37,21.37,0,0,1,1.66,7.34C183.4,355.84,181.12,361.51,179.86,367.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.3,354.76a24.87,24.87,0,0,0-.72-6.93c-.2-.78-1.18-4.54-2.45-4.45-.83.06-1,1.68-1,2.22-.28,2.27.45,4.59.9,6.8a95.08,95.08,0,0,1,1.65,13.65c0,.28-.09.58-.12.87s-.06.48-.09.72l0,.25a1.11,1.11,0,0,0,0,.19.21.21,0,0,0,.26.1c0-.18.05-.37.08-.56,0,.16,0,.31,0,.46h0l.09-.48,0-.11c0-.25,0-.51,0-.76A100.63,100.63,0,0,0,181.3,354.76Zm-1.52,10.32q-.19-4-.77-8c-.3-2.14-.71-4.26-1.16-6.37a22.05,22.05,0,0,1-.57-3.61c0-.94.09-4.38,1.87-2.25,1.28,1.56,1.59,4.85,1.75,6.76a34.45,34.45,0,0,1-.13,6.34C180.53,360.33,180.14,362.7,179.78,365.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.55,381.22h0a.45.45,0,0,1-.18,0c-4.58-.23-10.68.2-14.49-2.83-2.81-2.23-5.57-6.65-4.69-10.41,1-4.22,6.73.85,8.24,2.07A140.78,140.78,0,0,1,182.65,381s0,.05.06.08v0C182.75,381.16,182.66,381.2,182.55,381.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.71,381.09l-.79-.5c-3-1.89-5.94-3.92-8.76-6.08-.72-.55-5.87-5.13-6.65-3.5-.46,1,1.24,3,1.78,3.7a14.09,14.09,0,0,0,3.48,3.1c3,1.91,6.75,2.32,10.21,3.23a4.27,4.27,0,0,1,.48.13l.09.05h0C182.66,381.2,182.75,381.16,182.71,381.09Zm-9.05-2.61a14.16,14.16,0,0,1-4-2.67c-.76-.73-3.47-3.47-2.75-4.59.38-.6.7-.28,1.43.07.33.17.66.36,1,.56.77.51,1.47,1.1,2.19,1.66,1.25,1,2.53,2,3.83,2.93,2.13,1.55,4.32,3,6.55,4.4C179.17,380,176.27,379.66,173.66,378.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.92,371.79a27.05,27.05,0,0,1-7.85,13.7.15.15,0,0,1-.08.05.2.2,0,0,1-.24-.08.21.21,0,0,1,0-.27L183,385c.75-6.22,1.59-12.41,2.23-18.65.15-1.47,1.3-10.84,4.18-9.31,1.77.94,1.89,4.78,2.05,6.5A27.48,27.48,0,0,1,190.92,371.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.26,363.45c-.16-.52-.43-1.06-1-.69-1.12.69-1.56,5.1-1.75,6.31-.77,5-2,9.85-3.17,14.77l-.3,1.25-.28.37a.19.19,0,0,0,.23.08.42.42,0,0,0,0-.12c.13-.16.26-.33.38-.5h0a32,32,0,0,0,4.53-8.83,30.22,30.22,0,0,0,1.33-6.16C189.48,368,189.84,365.33,189.26,363.45Zm-5.88,21.12c0,.09-.12.17-.17.25,0-.17.11-.33.15-.5a89.49,89.49,0,0,0,2.81-11.43c.33-2,.54-3.94.94-5.89.17-.82.58-3.17,1.26-3.55s.67.53.74,1.06,0,1.07,0,1.43A31.49,31.49,0,0,1,183.38,384.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.83,398.92h-.92c0-.81,0-1.62,0-2.42-.11-3.25-.24-6.5-.43-9.75-.11-1.86-.24-3.7-.44-5.52a1.21,1.21,0,0,1,0-.19c0-.14,0-.29-.06-.45s0-.32-.06-.48a39.63,39.63,0,0,0-3.14-11.95c-.59-1.27-1.22-2.5-1.89-3.73l-.19-.35-.06-.09c-.06-.12-.13-.24-.2-.36s-.1-.18-.16-.28c-2.11-3.72-4.54-7.28-6.83-10.87-.66-1-1.32-2.06-2-3.09a1.18,1.18,0,0,1-.11-.19,1.7,1.7,0,0,1-.15-.22c-2.89-4.56-5.73-9.15-8.73-13.62-.11-.16.16-.31.27-.15,2,3,4.12,5.88,6.2,8.82l.83,1.17c.55.78,1.1,1.54,1.64,2.32,1.08,1.55,2.16,3.1,3.2,4.68A131.6,131.6,0,0,1,179,365.84c.18.35.35.71.52,1.08.11.22.22.45.31.67s.24.52.36.79a42.1,42.1,0,0,1,3.08,14.42c0,.34,0,.69.06,1,0,.15,0,.31,0,.48a2.11,2.11,0,0,0,0,.25c0,.11,0,.22,0,.34h0v.24c0,.3,0,.59,0,.9.13,3.25.22,6.5.29,9.74C183.75,396.84,183.79,397.88,183.83,398.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.5,340c-2.5-3.37-5.72-10.32-2-13.94a3.93,3.93,0,0,1,5.23-.38c2,1.41,2.83,4.08,3.46,6.28,1.7,5.9,2.82,11.91,4.93,17.69a5.67,5.67,0,0,1,.23.62c0,.12-.15.17-.19.05l-.21-.56C163.94,346.86,159.47,344,156.5,340Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.14,349.66s0-.07-.07-.1a42.47,42.47,0,0,1-2.34-4.36,84.64,84.64,0,0,1-3.6-9.66c-.4-1.26-2.2-7.45-4.42-5-.93,1-.8,2.88-.65,4.16a15.54,15.54,0,0,0,1.93,5.8c2,3.58,5.07,6.29,8.32,8.69.14.12.29.23.44.34l.09.15.06.1a.14.14,0,0,0,.25,0A.11.11,0,0,0,168.14,349.66Zm-1-.68a33.14,33.14,0,0,1-7.06-7.08,17.6,17.6,0,0,1-2.29-4.69,13.31,13.31,0,0,1-.5-2.27,10.16,10.16,0,0,1-.1-1.74c0-1.27.57-2.66,1.32-2.79.93-.17,1.24.37,1.85,1.44a9.67,9.67,0,0,1,.55,1.12,28.36,28.36,0,0,1,1,2.93c.52,1.64,1.05,3.27,1.64,4.88.4,1.1.82,2.18,1.29,3.25a43.44,43.44,0,0,0,2.75,5.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.33,349.43c-.41,3.34-1.05,6.64-1.73,9.94-.38,1.87-.78,3.73-1.16,5.61-.42,2.06-1,4.16-.47,6.24h0a1.46,1.46,0,0,1,0,.29l0,0a.25.25,0,0,1-.43-.07,1,1,0,0,1,0-.14l0,0a7.44,7.44,0,0,1-.72-1.73,44.7,44.7,0,0,1-3.29-15.13,35.41,35.41,0,0,1,1-9.29c.6-2.42,1.44-6,3.25-7.9,1.64-1.68,3,1,3.48,2.37C324.23,342.7,323.72,346.26,323.33,349.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.34,342.34c-1.22,0-2.1,3.93-2.54,5.63a33.82,33.82,0,0,0-1,8.2,43.8,43.8,0,0,0,2.52,14.56c.07.18.13.38.2.56a.09.09,0,0,0,0,0,.65.65,0,0,0,0,.13.25.25,0,0,0,.43.08c-.08-.41-.14-.81-.18-1.23s-.09-.73-.11-1.1a57.93,57.93,0,0,1,.74-12.05C321,352.51,322,342.34,320.34,342.34ZM319.46,370c.06.54.15,1.07.25,1.6-.12-.39-.25-.77-.36-1.16a48.08,48.08,0,0,1-2.3-12.85,34.76,34.76,0,0,1,.53-7.34,31.66,31.66,0,0,1,.95-3.84c.17-.53,1.06-3.82,1.81-3.66.53.12.65,3.08.66,3.15,0,.59,0,1.18,0,1.78,0,1.23-.1,2.45-.2,3.67-.23,2.65-.61,5.29-.93,7.93A45.8,45.8,0,0,0,319.46,370Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.52,358.65c-2.24,4.37-6,7.71-9.9,10.57-2.09,1.53-4.24,3-6.36,4.45a34.24,34.24,0,0,0-5.49,4.23,2.29,2.29,0,0,0-.21.23,8.6,8.6,0,0,0-1.14,1.57.14.14,0,0,1-.11.06,1.59,1.59,0,0,1-.07.2,0,0,0,0,1-.09,0l0-.22v0a.12.12,0,0,1,0-.16.16.16,0,0,1,0-.07,1.66,1.66,0,0,1,0-.22c.63-5.1,4.2-10.25,7.22-14.18s6.73-7.4,11.39-9.19c1.17-.45,3.83-1.69,5-.74S343,357.73,342.52,358.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.06,358.67c-1.06-1.06-4.19,1.56-5,2.18a52,52,0,0,0-6.47,6.29,46.48,46.48,0,0,0-8.26,12h0l-.11.14a.89.89,0,0,0,0,.22.1.1,0,0,0,0,.07.14.14,0,0,0,0,.17c.06-.06.1-.13.16-.18.39-.48.8-.95,1.22-1.41l.21-.22a101.15,101.15,0,0,1,9.67-8.55,48.31,48.31,0,0,0,6.45-6.26C337.38,362.5,340,359.57,339.06,358.67Zm-1,2.34c-2.64,4.38-7.21,7.58-11.09,10.77a53,53,0,0,0-7.37,7A49.46,49.46,0,0,1,327.27,368a67,67,0,0,1,5.25-5.41,27.85,27.85,0,0,1,3.19-2.55,11.24,11.24,0,0,1,2.16-1.17C339.35,358.45,338.53,360.26,338.08,361Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.71,390.09a.28.28,0,0,1-.23.12l.06.08a.08.08,0,0,1,0,.11.06.06,0,0,1-.1,0c-4.14-4.2-8.12-9.32-10.18-14.89a23.06,23.06,0,0,1-1.48-7.34c-.05-1.71-.14-5.17,1.33-6.42,3-2.51,5.65,8.15,6.05,9.76.73,2.93,1.22,5.92,1.89,8.86.74,3.22,1.72,6.39,2.68,9.55A.2.2,0,0,1,318.71,390.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.71,390.08c-.16-.27-.32-.54-.47-.82a49.89,49.89,0,0,1-5.32-14.33,45.41,45.41,0,0,0-2-7.45c-.24-.59-1-2.87-1.95-1.72-.51.6-.09,4.91.12,6a31.37,31.37,0,0,0,2.39,7.32,52,52,0,0,0,6.78,11c.08.1.15.2.23.29a.08.08,0,0,0,0-.11l-.06-.07A.28.28,0,0,0,318.71,390.08Zm-6-9.16a36.38,36.38,0,0,1-2.84-7.11,23.33,23.33,0,0,1-.62-3,15.92,15.92,0,0,1-.2-2.38c0-1.95.17-2.45.49-2.52s.48.17,1.06,1.33a13.32,13.32,0,0,1,.83,2.37c.3,1.15.56,2.3.81,3.47.51,2.32,1,4.65,1.66,6.93a38.54,38.54,0,0,0,4.1,9.32A59,59,0,0,1,312.71,380.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,379.86a14.83,14.83,0,0,1-2.71,5.64c-2.46,3.39-5.59,6.2-8.27,9.41-.4.48-.8,1-1.17,1.46,0,.06-.35.77-.35.71s0-.28.14-.74h0c.43-2.25,1.84-9,3.6-12.49a29.84,29.84,0,0,1,3.92-6.13c.76-.86,2.54-2.72,3.88-2.31S332.18,378.78,332,379.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.78,378.49c-1.43-.89-5.13,5.72-5.63,6.57a42,42,0,0,0-4.22,10.09c-.12.39-.22.79-.32,1.19s-.14.72-.14.74.31-.65.35-.71l.19-.25c.32-.42.65-.82,1-1.21,1.61-2.4,3.26-4.79,4.82-7.23a38,38,0,0,0,3-5.5C329,381.75,330.41,378.88,329.78,378.49Zm-.41,1.86c-2,5.75-6.21,10.29-9.39,15.39l-.15.25c0-.15.08-.3.13-.45a48.8,48.8,0,0,1,3.37-8.4,46.35,46.35,0,0,1,2.85-4.73,22.45,22.45,0,0,1,1.76-2.46c.3-.33,1.15-1.19,1.43-1S329.5,380,329.37,380.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.38,332.39c-4.26,9.8-15.46,14.37-20.31,23.82l0,.05c-.15.28-.29.58-.43.87a.19.19,0,0,1-.32.05.13.13,0,0,1,0-.16,2,2,0,0,1,.1-.21,51.32,51.32,0,0,1,6-17.16c2.45-4.52,5.81-8.74,10.46-11.12,1.15-.59,3.38-1.83,4.66-.86S346.91,331.18,346.38,332.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.54,332.81c-.54-.4-1.36.09-1.83.33a16.21,16.21,0,0,0-3.23,2.21,27.2,27.2,0,0,0-5.17,6.14,55.91,55.91,0,0,0-6.08,12.33c-.33,1-.61,2-.85,3,0,.13-.05.25-.08.37a.19.19,0,0,0,.32,0c.13-.3.27-.57.41-.86l0-.07a32.23,32.23,0,0,1,3-5.59A75.78,75.78,0,0,1,335.5,343C336.37,342.08,344.42,334.19,342.54,332.81Zm-.68,2.27c-1.29,2.3-3.31,4.18-5.06,6.14s-3.56,3.93-5.3,5.94a37.36,37.36,0,0,0-3.73,5.09,29.19,29.19,0,0,0-2.34,4.72,41,41,0,0,1,1.67-4.9s0,0,0-.06a72.92,72.92,0,0,1,4.14-8.24l.05-.1a33.71,33.71,0,0,1,4.72-6.59,19.94,19.94,0,0,1,3.36-2.86c1.41-.9,2.63-1.49,3-1S342.25,334.4,341.86,335.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.48,343.88c-1.28,2.76-2.5,5.57-3.71,8.37-.58,1.32-1.14,2.64-1.7,4l0,.07c-.2.48-.41,1-.62,1.43-1.84,4.3-3.88,8.7-5,13.26a39.91,39.91,0,0,0-1,7.36c0,.26,0,.52,0,.77h0c0,.14,0,.28,0,.42a1.77,1.77,0,0,0,0,.23c-.08,2.15-.05,4.31,0,6.41.06,2.92.3,5.82.58,8.72a1.22,1.22,0,0,0,0,.26c0,.13,0,.26,0,.39s0,.13,0,.2l0,.38c.1.93.18,1.86.26,2.8h-.89a57.83,57.83,0,0,1-1.08-8.63,1.15,1.15,0,0,1,0-.18c0-.28,0-.57-.05-.85s0-.69,0-1c0-.84-.06-1.67-.07-2.49a61.38,61.38,0,0,1,1-14.45l.09-.39c0-.05,0-.11,0-.16a2.29,2.29,0,0,1,.07-.28l.11-.44c.07-.27.15-.53.23-.79a2,2,0,0,1,.07-.23,93.08,93.08,0,0,1,4.92-11.9c.33-.71.66-1.4,1-2.1l.56-1.17.87-1.75s0,0,0-.06c1.37-2.75,2.79-5.48,4.14-8.24C331.33,343.65,331.55,343.75,331.48,343.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.61,398.65H99s.14-9.32,6.3-11.8a8.39,8.39,0,0,1,9.82,2.35s2.51-17.14,14-17.14,17,14.79,17,14.79,2.57-4.47,8.94-3.64S161.61,398.65,161.61,398.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.58,398.65s-1.92-9-5.75-10.34-6.17,2.64-6.17,2.64-.91-8.56-6.35-11.13-9.52,2.69-9.52,2.69-4.17-10.87-11.62-10.87S397,387.54,397,387.54s-4.4-4.74-8.91-2.06-4.51,13.17-4.51,13.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.19,398.65H52.42s1.9-8.14,5.73-8.72,5.61,3.2,5.61,3.2-.17-11.36,7-13.3,13.16,8.11,13.16,8.11,4.48-5.73,10.6-5.36,7.66,9.82,7.66,9.82S107.73,389.12,110.19,398.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.67,398.65H352.18s.08-5.28,3.57-6.68a4.73,4.73,0,0,1,5.56,1.33s1.42-9.71,7.93-9.71,9.61,8.38,9.61,8.38a5,5,0,0,1,5.07-2.07C387.53,390.38,387.67,398.65,387.67,398.65Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-167"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "45.75 398.92 96.82 398.67 147.88 398.59 250 398.42 352.12 398.58 403.19 398.67 454.25 398.92 403.19 399.16 352.12 399.25 250 399.42 147.88 399.25 96.82 399.16 45.75 398.92",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--social-tree--inject-167"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.14,143.34c0,9.58,0,55.31,43,62.76,0,0,.7,4.83,2.07,12.38,1.64,9.16,4.26,22.32,7.73,35.71a.24.24,0,0,0,0,.09c1.2,4.61,2.5,9.24,3.9,13.74a.3.3,0,0,0,0,.1c.14.43.27.85.4,1.27a232.45,232.45,0,0,1,6.7,26.16c13.22,68.4-14.95,103.37-14.95,103.37h59.21s14.67-64-16.47-128.23C273,258.8,295.93,249.13,306,227c8.49-18.74,8.24-110.91,4.12-116.85s-10.7-4.46-10.7,3.72,0,84.71-5.77,99.57-30.38,32.7-30.38,32.7-12.65-20.7-19.74-66h0c-3.32-21.32-5.42-48.07-4.4-80.68,0,0,0,0,0,0q.32-10.35,1.09-21.48c.59-8.51-8.25-4.78-11.19,2.67s-7.08,50.52-1.19,108.49c0,0-29.47-4.15-29.47-50.53C198.33,130,187.14,133.76,187.14,143.34Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.14,143.34c0,9.58,0,55.31,43,62.76,0,0,.7,4.83,2.07,12.38,1.64,9.16,4.26,22.32,7.73,35.71a.24.24,0,0,0,0,.09c1.2,4.61,2.5,9.24,3.9,13.74a.3.3,0,0,0,0,.1c.14.43.27.85.4,1.27a232.45,232.45,0,0,1,6.7,26.16c13.22,68.4-14.95,103.37-14.95,103.37h59.21s14.67-64-16.47-128.23C273,258.8,295.93,249.13,306,227c8.49-18.74,8.24-110.91,4.12-116.85s-10.7-4.46-10.7,3.72,0,84.71-5.77,99.57-30.38,32.7-30.38,32.7-12.65-20.7-19.74-66h0c-3.32-21.32-5.42-48.07-4.4-80.68,0,0,0,0,0,0q.32-10.35,1.09-21.48c.59-8.51-8.25-4.78-11.19,2.67s-7.08,50.52-1.19,108.49c0,0-29.47-4.15-29.47-50.53C198.33,130,187.14,133.76,187.14,143.34Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M265.9,270.06c3.4,11.58,8.05,22.86,11.42,34.48a235.52,235.52,0,0,1,7.62,35.67,182.85,182.85,0,0,1,1.16,35c-.52,8-2.35,15.83-3.74,23.71h5.39c6.4-18.34,5.54-39,2.24-57.51a262,262,0,0,0-9.48-35.81c-4-12-7.76-24.3-12.82-36C267.26,268.63,265.59,269,265.9,270.06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M242.08,201c2.37,24.44,13.19,48.17,20.94,71.5a192.43,192.43,0,0,1,9.31,72.86c0,.58-1,.59-1,0-.24-13.35-.47-26.79-3.22-39.95-2.49-11.89-6.42-23.56-10.36-35.11-3.88-11.33-8.18-22.57-11.37-34.08A158.4,158.4,0,0,1,240.94,201C240.91,200.3,242,200.32,242.08,201Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M242.19,398.92h6c1.66-3.34,3.15-6.73,4.56-10A142.75,142.75,0,0,0,262,358.66c3.85-20.39,3-40.61-1.66-60.82-.14-.58-1.05-.32-1,.23,3.51,20.07,2.47,41.22-2.16,61.06a170,170,0,0,1-9.37,28.58A124.12,124.12,0,0,1,242.19,398.92Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M264.37,372.55c1.37-4.5,2.2-10,4.52-14.21a5.28,5.28,0,0,1,4.23-2.86,1.08,1.08,0,0,1,.41-.05,4,4,0,0,1,.62.08,5.87,5.87,0,0,1,1.11.25c.73.25,1.55.75,1.68,1.52,0,0,0,.08,0,.12,2.63,3.75,1.66,11.77,1.29,14.72-.56,4.6-1.94,16.66-9.94,15.58C260.54,386.65,263.05,376.91,264.37,372.55Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M232.23,218.48c1.64,9.16,4.26,22.32,7.73,35.71a.24.24,0,0,0,0,.09c.44,1.53.9,3,1.35,4.57.92,3.06,1.78,6.11,2.55,9.17a.3.3,0,0,0,0,.1c.14.43.27.85.4,1.27a232.45,232.45,0,0,1,6.7,26.16c1.36-11.48-.83-22.88-4.21-34.32C242.52,246.76,237.71,232.57,232.23,218.48Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M304.55,188.94a4.92,4.92,0,0,1,.57-2.42,2,2,0,0,1,1.91-.83,1.92,1.92,0,0,1,1.59,1.24,1.21,1.21,0,0,1,.08.25,1.22,1.22,0,0,1,.27.56,3.47,3.47,0,0,1,0,1.11,2.39,2.39,0,0,1-.68,2.83,2.2,2.2,0,0,1-3.2-.38A3,3,0,0,1,304.55,188.94Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M271,248.78c14-14.9,30.36-32.37,30.31-53,0-.52.8-.48.87,0,3.16,22.68-12.92,39.51-30,54.09C271.42,250.54,270.34,249.52,271,248.78Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M273.16,258.77c.69-3.71,3.9-6.89,6.61-9.6,3.66-3.65,7.62-7,10.73-11.06.41-.53,1.34-.06,1,.52a64.61,64.61,0,0,1-8.11,10.12c-3.17,3.41-5.75,7.38-9.08,10.62A.68.68,0,0,1,273.16,258.77Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M307.66,123.35c0-.41.64-.38.69,0,2.68,18.12,3.12,37.47-.58,55.52-.11.58-1.11.43-1.11-.14C306.66,160.3,307.64,141.81,307.66,123.35Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M303.29,151.39c0-.14.25-.14.25,0,.1,12,.11,24.92-2.82,36.63-.17.69-1.37.54-1.36-.16C299.46,175.8,301.83,163.38,303.29,151.39Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M197.36,170.35c3,7.94,6.37,15.07,13.46,20.82a52.51,52.51,0,0,0,10.7,6.77c3.72,1.74,7.89,2.54,11.53,4.36.54.27.23.9-.29,1-8.71.93-18.68-5.45-24.34-10.88-6.13-5.88-11.63-13.64-12.23-21.89C196.15,169.86,197.15,169.8,197.36,170.35Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.06,152.4c1.77,14.81,10.46,27.32,21.82,37.69.32.29-.1.81-.5.58-14.15-8.48-21.08-23.4-21.59-38.27C195.78,152.24,196,152.25,196.06,152.4Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M229.47,120c.05-.55,1-.57,1,0-.65,32.91,6.44,65.25,9.21,98,0,.55-1,.68-1.07.13-3.2-16-5.66-32.32-7.66-48.53C228.89,153.07,227.79,136.52,229.47,120Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M233.93,139.11a131.21,131.21,0,0,0,9.56,41c-3.32-21.32-5.42-48.07-4.4-80.68a112.71,112.71,0,0,0-3.72,13.88A102,102,0,0,0,233.93,139.11Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M229.85,101.81c.49-2.93,1.88-5.62,2.5-8.52.13-.61,1.27-.63,1.38,0,.45,2.53-.43,4.65-1.15,7.09-1,3.43-1.23,6.93-1.72,10.43a.59.59,0,0,1-1.17,0A35.22,35.22,0,0,1,229.85,101.81Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M269.05,262.1c8.2,12.72,13.26,26.44,16.35,40.82.13.58-.76.81-1,.25-5.09-13.68-10.89-27.15-16.26-40.74C268,262,268.78,261.68,269.05,262.1Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M254.35,273.58c2.64,4.91,5.61,12.13,4.41,17.66,0,.11-.21.13-.27,0-1.43-2.46-1.8-5.33-2.51-8-.83-3.11-1.9-6.17-2.71-9.28C253.12,273.43,254.05,273,254.35,273.58Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M272.46,396.93a35.79,35.79,0,0,0,7.26-16.18c1.37-7,2.85-14.58,1.43-21.68-1.17-5.82-3.41-11.33-4.27-17.23a81.83,81.83,0,0,1-.28-21.15c0-.45.81-.47.79,0A80.9,80.9,0,0,0,280,345c1.78,6.59,4.65,12.95,4.61,19.81-.05,10.48-1.82,25.48-11.1,32.84C273,398.08,272,397.52,272.46,396.93Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M259.89,398.92h3.51a12.35,12.35,0,0,0-.47-5.26c-1.17-4.08-3.5-8.58-2.8-12.9,0-.24-.35-.44-.48-.18C256.75,386.64,259.08,392.76,259.89,398.92Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M260.8,376.87s0,0,0,0a2.74,2.74,0,0,0-.43,1.71s0,0,0,0A2.78,2.78,0,0,1,260.8,376.87Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 383.56,
    cy: 248,
    r: 22.51,
    transform: "translate(-73.05 236.62) rotate(-31.46)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.51,241.92C394,236.44,390.19,231,383.56,231s-10.4,5.45-10.95,10.93c-.83,8.45,4.87,16.11,10.95,23.1C389.65,258,395.35,250.37,394.51,241.92ZM383.56,248a6,6,0,1,1,6-6A6,6,0,0,1,383.56,248Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.15,
    cy: 76.98,
    r: 47.5,
    transform: "translate(116.5 300.45) rotate(-76.99)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,63.82c-.11,3,0,6.08,0,9.35h11.8c-.5,3.89-.93,7.48-1.51,11,0,.36-.93.79-1.44.82-2.84.07-5.68,0-8.78,0v39.36a46.33,46.33,0,0,1-12.52-2V85.15H223.19V73.28H233.3c0-.9.11-1.62.11-2.3.07-3.13,0-6.26.25-9.36.64-6.8,4.82-11.58,11.55-12.52,4.17-.57,8.52-.11,12.91-.11v10.8c-1.55,0-3.13,0-4.68,0a19.66,19.66,0,0,0-4.13.28A3.89,3.89,0,0,0,246,63.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.58,
    cy: 206.68,
    r: 47.5,
    transform: "translate(-99.11 174.08) rotate(-45)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.64,229a26.53,26.53,0,0,0,17.12-5.27c-7.08-2.15-9.9-4.31-10.93-8.34l4.74-.23c-5.58-2.15-8.87-5.9-9.3-12l4.89,1.29c-5.12-6.45-6.16-11.45-3.1-16.12a35.3,35.3,0,0,0,25.1,12.56c0-.8-.09-1.4-.11-2-.2-5.29,2-9.29,6.73-11.62s9.26-1.69,13.33,1.61a2.46,2.46,0,0,0,2.69.56c1.91-.72,3.83-1.41,5.93-2.18a12.21,12.21,0,0,1-4.66,6c.05.11.09.23.13.34l5.87-1.51.24.24c-1.52,1.52-3,3.12-4.58,4.55a3.12,3.12,0,0,0-1.27,2.62,34.35,34.35,0,0,1-31.26,34.42,34.86,34.86,0,0,1-20.39-4.16C135.41,229.46,135,229.21,134.64,229Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.56,
    cy: 257.02,
    r: 33.31,
    transform: "translate(-27.73 482.61) rotate(-82.86)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--2dqxsktif--inject-167"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.5,239.55a.43.43,0,0,0,.14,0,4.09,4.09,0,0,1,2.64,1.19,4,4,0,0,1,1.18,2.34,4.1,4.1,0,0,1-1.41,3.87,4.05,4.05,0,0,1-2,.94,4.13,4.13,0,0,1-1.16.06,4.19,4.19,0,0,1-3.64-3,3.6,3.6,0,0,1-.15-.87c0-.06,0-.13-.07-.15v-.37c.07,0,.06-.09.07-.15s0-.24,0-.36a4.14,4.14,0,0,1,1-2.17,4.1,4.1,0,0,1,2.81-1.34.74.74,0,0,0,.14,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.48,254.24l.11-.14a7.7,7.7,0,0,1,4.61-3.26,10.88,10.88,0,0,1,1.89-.26,11.11,11.11,0,0,1,1.29,0,9.39,9.39,0,0,1,3.57.89,6.17,6.17,0,0,1,2.68,2.55,9.1,9.1,0,0,1,.89,2.25,11.21,11.21,0,0,1,.33,1.63c0,.27,0,.55.07.83,0,.51.06,1,.08,1.54v0c0,.49,0,1,0,1.47l0,4.92v7.44c0,.28,0,.29-.3.29h-6.09l-.46,0h-.08c-.35,0-.35-.1-.35-.36V268q0-3.06,0-6.12a7.75,7.75,0,0,0-.3-2.29,4.41,4.41,0,0,0-.56-1.23,2.82,2.82,0,0,0-1.84-1.22,3.69,3.69,0,0,0-.87-.1c-.32,0-.63,0-.94,0a3.45,3.45,0,0,0-2.95,2.13,6.6,6.6,0,0,0-.47,1.74,13.51,13.51,0,0,0-.12,1.91V274a2.25,2.25,0,0,1,0,.26c0,.12-.06.16-.17.17h-6l-.66,0h-.09c-.3,0-.32-.11-.32-.33s0-.22,0-.33V251.59a1.21,1.21,0,0,1,0-.19c0-.17.06-.23.23-.24h6.52c.16,0,.22.06.22.23s0,.56,0,.84v1.24c0,.2,0,.4,0,.6a.92.92,0,0,0,0,.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.67,262.8V251.49a1.21,1.21,0,0,1,0-.19.13.13,0,0,1,.14-.13h6.83c.26,0,.32.07.32.33,0,.85,0,1.7,0,2.56q0,10,0,20a1.93,1.93,0,0,1,0,.24c0,.09-.07.16-.17.16l-.52,0h-5.75l-.44,0H243c-.25,0-.32-.06-.32-.34V262.8Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 355.86,
    cy: 180.15,
    r: 47.46,
    transform: "translate(99.49 485.72) rotate(-76.85)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.16,164.52c0-7.7-4.84-12.68-12.47-12.76q-15.85-.15-31.7,0c-7.47.08-12.31,5-12.43,12.49-.07,5.27,0,10.55,0,15.82s0,10.32,0,15.48c.06,7.88,4.87,12.91,12.66,13q15.67.17,31.36,0c7.64-.09,12.54-5.11,12.58-12.72Q384.25,180.18,384.16,164.52Zm-5.05,31.39c-.05,4.87-2.68,7.56-7.55,7.6q-15.68.09-31.35,0c-4.9,0-7.55-2.72-7.57-7.57q-.08-15.81,0-31.63c0-4.83,2.72-7.6,7.54-7.63q15.68-.12,31.35,0c4.84,0,7.53,2.79,7.58,7.61.06,5.27,0,10.54,0,15.81S379.17,190.64,379.11,195.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.9,165.3a14.79,14.79,0,1,0,14.69,15A14.76,14.76,0,0,0,355.9,165.3Zm-.19,24.64a10,10,0,0,1-9.7-9.74,9.86,9.86,0,0,1,19.72,0A10,10,0,0,1,355.71,189.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.09,165a3.07,3.07,0,0,1-3.53,3.06,3.1,3.1,0,0,1-3.22-3.69c.15-2.07,1.5-3,3.57-3.14C374,161.53,375.25,162.73,375.09,165Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326.32,
    cy: 258.33,
    r: 32.09,
    transform: "translate(-0.91 515.49) rotate(-76.53)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.35 270.64 314.35 246.01 343.73 258.33 314.35 270.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.91,
    cy: 265.98,
    r: 22.76,
    transform: "translate(-85.45 95.88) rotate(-22.17)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.6,268.88c-3.76,7.57-12.69,12.07-12.69,12.07s-8.93-4.5-12.68-12.07c-3.13-6.32-1.15-13.15,3.79-14.64,7.07-2.14,8.89,10.19,8.89,10.19s1.81-12.33,8.9-10.19C215.74,255.73,217.73,262.56,214.6,268.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.84,
    cy: 94.81,
    r: 33.31,
    transform: "translate(29.57 261) rotate(-45)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--QfoS7x.tif--inject-167"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.54,81.18a7.35,7.35,0,0,0,.58.91l.05,0A7.54,7.54,0,0,1,339.54,81.18Zm.64,1h0l.35.25Zm5.65,6V85.59a9.05,9.05,0,0,1-1-.24,9.44,9.44,0,0,1-1.69-.67,8.16,8.16,0,0,1-1.49-1,6.11,6.11,0,0,1-.7-.64l-.1-.11-.09-.09a4.8,4.8,0,0,1-.55-.71.84.84,0,0,1-.24-.16,9.55,9.55,0,0,1-1.05-1.06A9.18,9.18,0,0,1,337.67,79a10.18,10.18,0,0,1-.76-2.15c-.07-.27-.12-.54-.18-.81h0v0h0v-.07h-5.08c-.12,0-.14,0-.14.14v24.1c0,.7,0,1.41,0,2.11,0,.4,0,.8-.08,1.2a9.44,9.44,0,0,1-.28,1.5,3,3,0,0,1-.3.62,5.94,5.94,0,0,1-1.08,1.36,5.46,5.46,0,0,1-2.66,1.33l-.62.08c-.2,0-.41,0-.61,0a5.64,5.64,0,0,1-2.07-.43,5.19,5.19,0,0,1-1.33-.77,4.19,4.19,0,0,1-1.07-1.31,10.6,10.6,0,0,1-.44-1.15,5.42,5.42,0,0,0,.42,1.1,0,0,0,0,1,0,0v0a2.42,2.42,0,0,1-.42-.29l0,0a4.28,4.28,0,0,1-.45-.4,4.41,4.41,0,0,1-.94-1.51,7.08,7.08,0,0,1-.28-1,5.6,5.6,0,0,1-.1-.81c0-.16,0-.33,0-.49a6.63,6.63,0,0,1,.27-1.71,5.31,5.31,0,0,1,.79-1.6,4.91,4.91,0,0,1,1.45-1.31,5.68,5.68,0,0,1,1.68-.67,7,7,0,0,1,.78-.12,7.23,7.23,0,0,1,1.23,0,4.89,4.89,0,0,1,.85.08c.12,0,.14,0,.14-.12V90.35c-.42,0-.84,0-1.27,0a14.71,14.71,0,0,0-1.47.17,13.05,13.05,0,0,0-1.61.4,10.67,10.67,0,0,0-1.11.44,11,11,0,0,0-1.61.9c-.37.25-.71.52-1,.8a10.54,10.54,0,0,0-1,.93,10.38,10.38,0,0,0-1.06,1.32,14.4,14.4,0,0,0-1,1.74,14.05,14.05,0,0,0-.58,1.39,16.17,16.17,0,0,0-.55,2c-.06.33-.1.66-.14,1a14.15,14.15,0,0,0-.09,2c0,.38.05.76.09,1.14a11.74,11.74,0,0,0,.33,1.77,12.63,12.63,0,0,0,.62,1.79,11.7,11.7,0,0,0,1,1.87c.09.14.19.28.27.43s.52.62.82.94c-.22-.24-.42-.49-.63-.73a.06.06,0,0,1,0-.06l.09.06a2.31,2.31,0,0,1,.24.2l0,0a13,13,0,0,0,1.07.76,11.66,11.66,0,0,0,1.47.81,15,15,0,0,0,2,.76,9.4,9.4,0,0,0,1,.21l.92.15a3.15,3.15,0,0,0,.43,0,12.81,12.81,0,0,0,1.39.07c.4,0,.79,0,1.19-.09a10.89,10.89,0,0,0,1.39-.23,10.28,10.28,0,0,0,2-.66,10.54,10.54,0,0,0,2.12-1.25,10.4,10.4,0,0,0,1.47-1.34,9.91,9.91,0,0,0,1-1.19,11.83,11.83,0,0,0,1.06-1.82,13.77,13.77,0,0,0,.82-2.22c.12-.42.22-.85.3-1.28s.1-.62.15-.94a4.53,4.53,0,0,0,.05-.53c.14-2.41,0-4.82.06-7.23s0-4.83,0-7.25V87.5l.25.21a10,10,0,0,0,1.24.89c.39.24.79.45,1.2.65a17.41,17.41,0,0,0,2.22.83c.54.16,1.1.3,1.66.41s.86.16,1.29.21c.26,0,.52.06.79.08l.52,0c.1,0,.11,0,.11-.11Zm-29.6,22.29h0Zm.09.07h0S316.34,110.57,316.32,110.56Zm.66.8,0,.06Zm16.59-35.42h0Zm3.16,0a.15.15,0,0,0,0,.07v-.07Z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.43,92.39c0,.09,0,.12-.12.12-.38,0-.75-.05-1.13-.09s-.6-.07-.9-.12-.67-.13-1-.2a16.41,16.41,0,0,1-1.94-.54,13.79,13.79,0,0,1-1.5-.6,12.09,12.09,0,0,1-1.75-1,10.14,10.14,0,0,1-.91-.71s0,0,0,0c0,1,0,2,0,3q0,5.34,0,10.66a10,10,0,0,1-.08,1.09c0,.24-.06.48-.1.72s-.12.69-.19,1-.24.93-.39,1.39a15.26,15.26,0,0,1-.66,1.62,12.93,12.93,0,0,1-1.08,1.83,7.46,7.46,0,0,1-.61.78c-.18.22-.38.44-.59.65a11.81,11.81,0,0,1-.91.82c-.3.23-.6.45-.91.65a11.67,11.67,0,0,1-1.68.88,12.69,12.69,0,0,1-1.58.52c-.33.08-.66.14-1,.19s-.67.09-1,.13c-.09,0-.19,0-.28,0h-1.32s-.06,0-.09,0a7.89,7.89,0,0,1-1.09-.11l-.86-.13a8.46,8.46,0,0,1-1.85-.51c-.35-.13-.71-.28-1.05-.44a13.81,13.81,0,0,1-1.72-1,10.41,10.41,0,0,1-.92-.68,13.41,13.41,0,0,1-1.11-1v0l0,0,0-.06c-.3-.32-.83-.92-.82-.94a1.84,1.84,0,0,1,.28.21l.24.2,0,0a13,13,0,0,0,1.07.76,11.66,11.66,0,0,0,1.47.81,15,15,0,0,0,2,.76,9.4,9.4,0,0,0,1,.21l.92.15a3.15,3.15,0,0,0,.43,0,12.81,12.81,0,0,0,1.39.07c.4,0,.79,0,1.19-.09a10.89,10.89,0,0,0,1.39-.23,10.28,10.28,0,0,0,2-.66,10.54,10.54,0,0,0,2.12-1.25,10.4,10.4,0,0,0,1.47-1.34,9.91,9.91,0,0,0,1-1.19,11.83,11.83,0,0,0,1.06-1.82,13.77,13.77,0,0,0,.82-2.22c.12-.42.22-.85.3-1.28s.1-.62.15-.94a4.53,4.53,0,0,0,.05-.53c.14-2.41,0-4.82.06-7.23s0-4.83,0-7.25V87.5l.25.21a10,10,0,0,0,1.24.89c.39.24.79.45,1.2.65a17.41,17.41,0,0,0,2.22.83c.54.16,1.1.3,1.66.41s.86.16,1.29.21c.26,0,.52.06.79.08l.52,0c.1,0,.11,0,.11-.11v-5.1h0a2.44,2.44,0,0,0,.47.09c.24,0,.49.07.73.09s.21,0,.31,0,.07,0,.07.08,0,0,0,0C347.43,88.06,347.42,90.23,347.43,92.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.36,90.35h0c-.42,0-.84,0-1.27,0a14.71,14.71,0,0,0-1.47.17,13.05,13.05,0,0,0-1.61.4,10.67,10.67,0,0,0-1.11.44,11,11,0,0,0-1.61.9c-.37.25-.71.52-1,.8a10.54,10.54,0,0,0-1,.93,10.38,10.38,0,0,0-1.06,1.32,14.4,14.4,0,0,0-1,1.74,14.05,14.05,0,0,0-.58,1.39,16.17,16.17,0,0,0-.55,2c-.06.33-.1.66-.14,1a14.15,14.15,0,0,0-.09,2c0,.38.05.76.09,1.14a11.74,11.74,0,0,0,.33,1.77,12.63,12.63,0,0,0,.62,1.79,11.7,11.7,0,0,0,1,1.87c.09.14.19.28.27.43l-.26-.23a10.41,10.41,0,0,1-1.21-1.36,12.47,12.47,0,0,1-1-1.53,11.9,11.9,0,0,1-.89-2.12,12.15,12.15,0,0,1-.4-1.66q-.07-.49-.12-1a1.81,1.81,0,0,0,0-.4v-1.58s0,0,0-.07a7.32,7.32,0,0,1,.09-.93,13.86,13.86,0,0,1,.92-3.47,13.35,13.35,0,0,1,1.35-2.46,12.19,12.19,0,0,1,.76-1,9.07,9.07,0,0,1,1-1,11.68,11.68,0,0,1,1.88-1.41,11,11,0,0,1,2.27-1,9.88,9.88,0,0,1,1.69-.4l.95-.12a11.17,11.17,0,0,1,1.53,0,9.39,9.39,0,0,1,1.19.1,2.73,2.73,0,0,0,.4,0c.08,0,.11,0,.11.12C326.36,89.41,326.36,89.88,326.36,90.35Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.73,75.94h-5.08c-.12,0-.14,0-.14.14v24.1c0,.7,0,1.41,0,2.11,0,.4,0,.8-.08,1.2a9.44,9.44,0,0,1-.28,1.5,3,3,0,0,1-.3.62,5.94,5.94,0,0,1-1.08,1.36,5.46,5.46,0,0,1-2.66,1.33l-.62.08c-.2,0-.41,0-.61,0a5.64,5.64,0,0,1-2.07-.43,5.19,5.19,0,0,1-1.33-.77,4.19,4.19,0,0,1-1.07-1.31l.25.14a5.92,5.92,0,0,0,3.21.68,5.53,5.53,0,0,0,2.14-.6,5.38,5.38,0,0,0,1-.69A5.53,5.53,0,0,0,329.2,104a3.36,3.36,0,0,0,.52-1.37l.15-1c0-.2,0-.41,0-.62s0-.71,0-1.06V74.35s0-.08.07-.07h6.41c.17,0,.17,0,.17.16a7.85,7.85,0,0,0,.13,1.37A.57.57,0,0,1,336.73,75.94Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,91.88V97.6c0,.14,0,.14-.14.11a3.44,3.44,0,0,0-.45,0l-.66,0a7.11,7.11,0,0,0-1.72.16,5.37,5.37,0,0,0-2.45,1.2,5,5,0,0,0-1.12,1.42,5.45,5.45,0,0,0-.54,1.51q-.06.33-.09.66a6,6,0,0,0,0,.85,5.3,5.3,0,0,0,.14,1l.06.26a10.6,10.6,0,0,0,.44,1.15h0a3.12,3.12,0,0,1-.45-.29,4.28,4.28,0,0,1-.45-.4,4.41,4.41,0,0,1-.94-1.51,7.08,7.08,0,0,1-.28-1,5.6,5.6,0,0,1-.1-.81c0-.16,0-.33,0-.49a6.63,6.63,0,0,1,.27-1.71,5.31,5.31,0,0,1,.79-1.6,4.91,4.91,0,0,1,1.45-1.31,5.68,5.68,0,0,1,1.68-.67,7,7,0,0,1,.78-.12,7.23,7.23,0,0,1,1.23,0,4.89,4.89,0,0,1,.85.08c.12,0,.14,0,.14-.12V90.35h0a.5.5,0,0,0,.17,0,8.79,8.79,0,0,1,1.14.11,1.52,1.52,0,0,0,.21,0c.07,0,.08,0,.08.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.18,82.15h0a.84.84,0,0,1-.24-.16,9.55,9.55,0,0,1-1.05-1.06A9.18,9.18,0,0,1,337.67,79a10.18,10.18,0,0,1-.76-2.15c-.07-.27-.12-.54-.18-.81h0v0h0a.2.2,0,0,1,0-.08h1.36c.06,0,.08,0,.08.08a6.63,6.63,0,0,0,.09,1.18,12.25,12.25,0,0,0,.41,1.89,10.92,10.92,0,0,0,.62,1.59,4.47,4.47,0,0,0,.25.49h0a7.54,7.54,0,0,0,.63.95h0v0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.85,84.18v1.4h0a9.05,9.05,0,0,1-1-.24,9.44,9.44,0,0,1-1.69-.67,8.16,8.16,0,0,1-1.49-1,6.11,6.11,0,0,1-.7-.64l-.1-.11a6.23,6.23,0,0,1-.64-.8h0l.35.25.05,0a8.56,8.56,0,0,0,1.32.74,8,8,0,0,0,.92.37,10.86,10.86,0,0,0,1.75.42,12.1,12.1,0,0,0,1.21.13C345.84,84.1,345.85,84.12,345.85,84.18Z",
    style: {
      fill: "#FFC727"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 256.83,
    cy: 173.66,
    r: 47.5,
    transform: "translate(27.51 382.31) rotate(-76.36)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.53,204c1.32-4.74,2.48-9.14,3.78-13.5a4.89,4.89,0,0,0-.36-3.9c-9.17-18.48,3-40.81,23.53-43.32,18.89-2.31,34.87,11.93,34.46,30.71-.33,15.4-13.39,28.67-28.84,29.36A32.72,32.72,0,0,1,244,200.47a4.86,4.86,0,0,0-2.9-.22C236.36,201.38,231.66,202.65,226.53,204Zm7.39-7.17c3-.78,5.55-1.52,8.14-2.06a4.34,4.34,0,0,1,2.68.35A27.17,27.17,0,0,0,257,198.3c15.69.27,28.33-14.3,25.34-29.58-2.07-10.57-8.56-17.5-19.05-19.9-10.76-2.46-19.92,1-26.43,9.89-6.36,8.7-6.53,18.06-1.33,27.54a4.68,4.68,0,0,1,.38,3C235.43,191.67,234.67,194.06,233.92,196.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,161c2.07-2.79,4.84-2.24,6.29.84.57,1.21.7,1.61,1.26,3,.84,2.08.65,3.47-.84,4.81-1.09,1-1,1.83-.24,2.95a21.46,21.46,0,0,0,9.24,7.81,2,2,0,0,0,2.8-.63c2.68-3.19,2.72-3.16,6.5-1.38l1.3.62c2.9,1.39,3.34,4,1,6.3a8.5,8.5,0,0,1-8.53,2.07c-8.15-2.07-14-7.19-18.49-14.05a11.67,11.67,0,0,1-2.32-6.9A10.15,10.15,0,0,1,244,161Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.08,
    cy: 149.23,
    r: 22.51,
    transform: "translate(-47.96 53.73) rotate(-22.18)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--xsrjP0--inject-167"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.66,159.21c-.67-.42-1.26-1-2.15-.94-.35,0-.27-.25-.28-.43q0-5.07,0-10.14a.55.55,0,0,1,.28-.58c2.58-1.31,3.69-3.87,5.26-6.06a10.11,10.11,0,0,0,1.85-7.67,1,1,0,0,1,.92-1.26,1.68,1.68,0,0,1,1.93.6,13.44,13.44,0,0,1,1.49,4.42,15.24,15.24,0,0,1-.46,3.79c-.11.93-.32,1.85-.5,2.79.23.16.49.08.74.08l8.56,0c1.2,0,1.79.34,2,1.14A2.29,2.29,0,0,1,128,147.4c-.21.11-.59,0-.62.35s.37.3.57.44c1,.7.85,2.16-.34,3-.29.2-.85.11-.86.53s.52.34.75.57a1.93,1.93,0,0,1-.81,3,4.45,4.45,0,0,0-.51.19c-.14.1-.28.21,0,.4a1.68,1.68,0,0,1,0,3l-.38.27a2.39,2.39,0,0,1-1.5.33l-13.42,0A1.58,1.58,0,0,1,109.66,159.21Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.92,153.3c0-2.15,0-4.29,0-6.44,0-.43,0-.65.58-.64q3.91,0,7.85,0c.51,0,.59.17.59.63q0,6.48,0,13c0,.55-.14.71-.69.7-2.54,0-5.08,0-7.62,0-.63,0-.72-.21-.71-.76C97,157.59,96.93,155.45,96.92,153.3Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 220.13,
    cy: 228.65,
    r: 11.27,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--K0pxJE--inject-167"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.94,220.82a4.72,4.72,0,0,1,2.91.82,4.11,4.11,0,0,1,1.5,2.09,3.93,3.93,0,0,1,.14.91,12.71,12.71,0,0,1,0,1.38c0,.38-.05.76-.07,1.14,0,.16,0,.18.15.25a1,1,0,0,0,.67,0,2,2,0,0,0,.34-.14.79.79,0,0,1,.85.18.38.38,0,0,1,0,.53,1.62,1.62,0,0,1-.65.4c-.19.07-.39.12-.58.21a2.21,2.21,0,0,0-.34.18.74.74,0,0,0-.27.86,4.4,4.4,0,0,0,.55,1.08,5.23,5.23,0,0,0,1.6,1.61,4,4,0,0,0,1.37.53.18.18,0,0,1,.15.28.64.64,0,0,1-.32.31,3.93,3.93,0,0,1-1.06.37l-.62.11a.27.27,0,0,0-.22.19c-.07.21-.1.44-.16.66s-.13.28-.37.25-.58-.1-.87-.13a2.74,2.74,0,0,0-2,.55,9.6,9.6,0,0,1-.93.64,3.17,3.17,0,0,1-1.7.41,3.32,3.32,0,0,1-1.81-.63c-.31-.22-.6-.45-.93-.64a2.18,2.18,0,0,0-1-.32,4.82,4.82,0,0,0-1.42.12h0c-.33,0-.37,0-.44-.27s-.09-.38-.13-.57a.3.3,0,0,0-.29-.26,5.52,5.52,0,0,1-1.54-.43,1,1,0,0,1-.25-.16.44.44,0,0,1-.17-.23.17.17,0,0,1,.15-.25,3.87,3.87,0,0,0,1-.35,4.6,4.6,0,0,0,1.63-1.37,6,6,0,0,0,.79-1.31,1.08,1.08,0,0,0,.1-.35.74.74,0,0,0-.36-.74,2.18,2.18,0,0,0-.62-.28,2.29,2.29,0,0,1-.74-.35.75.75,0,0,1-.16-.15.37.37,0,0,1,.06-.56.7.7,0,0,1,.77-.1,1.38,1.38,0,0,0,.72.18.71.71,0,0,0,.4-.11.1.1,0,0,0,.06-.12c0-.52-.06-1.05-.08-1.57a9.14,9.14,0,0,1,0-1.17,3.41,3.41,0,0,1,.17-.9,4.1,4.1,0,0,1,2.52-2.51A4.22,4.22,0,0,1,219.94,220.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 305.64,
    cy: 135.53,
    r: 11.27,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.65,
    cy: 131.27,
    r: 3.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.14,141.62V143h-13v-1.37a6.5,6.5,0,0,1,13,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.44,124.31a34.82,34.82,0,0,0,58.21,22l17.43,2.56-8.72-15.07a34.84,34.84,0,1,0-66.92-9.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.87,95.53a34.74,34.74,0,0,1,29.19-9.69,35.16,35.16,0,0,1,14.87,5.58A35.67,35.67,0,0,1,201.84,103,35.19,35.19,0,0,1,204,134.09l0-.6,8.67,15.1.64,1.11-1.26-.19-17.41-2.67.41-.13a35.11,35.11,0,0,1-17.24,8.51,30,30,0,0,1-4.82.5,34.92,34.92,0,0,1-22.62-7,37.58,37.58,0,0,1-3.68-3.11,40.26,40.26,0,0,1-3.16-3.63,35,35,0,0,1,3.4-46.44Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.67,121.74a4.22,4.22,0,1,0,4.22-4.22A4.22,4.22,0,0,0,151.67,121.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.78,121.74a4.22,4.22,0,1,0,4.22-4.22A4.22,4.22,0,0,0,166.78,121.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.9,121.74a4.22,4.22,0,1,0,4.22-4.22A4.22,4.22,0,0,0,181.9,121.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.31,112.71a22.39,22.39,0,0,1-37.42,14.16l-11.2,1.64,5.61-9.68a22.17,22.17,0,0,1-1.54-10.78,22.4,22.4,0,1,1,44.55,4.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.31,112.71a22.67,22.67,0,0,1-4.52,11.35,26.46,26.46,0,0,1-2,2.33,25.17,25.17,0,0,1-2.37,2,21.62,21.62,0,0,1-5.4,3,22.22,22.22,0,0,1-6,1.44,21.51,21.51,0,0,1-3.11.06,20.24,20.24,0,0,1-3.1-.32,22.61,22.61,0,0,1-11.08-5.47l.27.08-11.19,1.72-.81.12.41-.71,5.57-9.71,0,.38a22.62,22.62,0,1,1,43.42-6.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.52,111.06a2.71,2.71,0,1,1-2.71-2.71A2.72,2.72,0,0,1,399.52,111.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.8,111.06a2.71,2.71,0,1,1-2.71-2.71A2.71,2.71,0,0,1,389.8,111.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.09,111.06a2.71,2.71,0,1,1-2.71-2.71A2.72,2.72,0,0,1,380.09,111.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.99,
    cy: 60.22,
    r: 22.51,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M188.41,54a4.57,4.57,0,1,1-4.57-4.56A4.57,4.57,0,0,1,188.41,54Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M191.73,66.58v1.67H176V66.58a7.89,7.89,0,0,1,15.78,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M176.72,56.75a4.57,4.57,0,1,1-4.57-4.56A4.57,4.57,0,0,1,176.72,56.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,69.33V71H164.25V69.33a7.9,7.9,0,0,1,15.79,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.18,
    cy: 218.51,
    r: 11.27,
    transform: "translate(15.19 456.24) rotate(-76.65)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.82,222.28h-.91a1,1,0,1,1,0-2.07h1.28l.59-3.48h-1.16a1,1,0,0,1,0-2.07h1.53l.39-2.38a1,1,0,0,1,1-.86,1.07,1.07,0,0,1,1,1.22l-.36,2h3.13l.4-2.38a1,1,0,0,1,1.06-.86,1.05,1.05,0,0,1,1,1.22l-.34,2h.92a1,1,0,0,1,0,2.07h-1.28l-.6,3.48h1.14a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-1.5l-.42,2.45a1,1,0,0,1-1,.86,1.05,1.05,0,0,1-1-1.21l.38-2.1H294l-.42,2.45a1,1,0,0,1-1.05.86,1,1,0,0,1-1-1.21Zm5.62-2.07.6-3.48h-3.12l-.6,3.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.7,
    cy: 76.04,
    r: 11.27,
    transform: "translate(-12.91 32.4) rotate(-12.31)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.83,68.64a7.45,7.45,0,1,0,1.75,14.8,7,7,0,0,0,1.78-.45.6.6,0,0,0,.38-.83.49.49,0,0,0-.25-.34.7.7,0,0,0-.57,0,5.43,5.43,0,0,1-1.49.34,6.13,6.13,0,1,1,5.36-6.82,5.78,5.78,0,0,1-.35,2.86,2,2,0,0,1-1,1.11l-.15,0c-.19,0-.24,0-.25,0a2.26,2.26,0,0,1-.18-.39c-.17-.72-.35-3-.35-3l0-.27a3.86,3.86,0,1,0-3.33,4.51,3.64,3.64,0,0,0,2.4-1.33l0,.34a1.88,1.88,0,0,0,.49,1,1.56,1.56,0,0,0,1.37.47,2.24,2.24,0,0,0,.44-.1,3.48,3.48,0,0,0,1.73-1.79l0,0,0,0a7.3,7.3,0,0,0,.38-3.47A7.45,7.45,0,0,0,142.83,68.64ZM144,78.72a2.58,2.58,0,0,1-2.79-2.4,2.62,2.62,0,0,1,2.16-3,2.67,2.67,0,0,1,2.82,2.41A2.63,2.63,0,0,1,144,78.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-167"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.93,456.31c.73-2.08,38.82-50.29,41.37-51.18.3-.12,16.62,12,16.62,12,.67.92,32.31-5.08,32.31-5.08l-.48,38-57.36-2.42s-7.84,4.4-15,8h0a87.11,87.11,0,0,1-9.42,4.33C155.05,460.63,149.18,458.37,149.93,456.31Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.93,460a82.22,82.22,0,0,0,9.42-4.34h0c7.16-3.57,15-8,15-8l12.77.54,20.66-31.84c-4.4.68-7.69,1.08-7.9.78,0,0-16.32-12.13-16.61-12-2.56.89-40.65,49.1-41.38,51.17S155.05,460.64,157.93,460Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,456.36c.77-2.13,39-50.31,41.65-51.22,1-.35,9,4.82,16.68,12l-24.7,31s-22.43,11.29-25.41,12S148.81,458.49,149.59,456.36Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.06,457.2c6.61-7.91,32.53-40.48,38.47-48.81,0-.07,0-.1-.05,0-6.73,7.71-32.38,40.48-38.55,48.75C151.8,457.27,151.92,457.37,152.06,457.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,458.44a8.29,8.29,0,0,0,1.87-6.4,8.06,8.06,0,0,0-2.88-5.23c-.05,0-.12.06-.08.1a9.56,9.56,0,0,1,1,11.45C161.86,458.43,162,458.5,162,458.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.4,450.07c2.61-3.2,4.45-7.85,3.4-12,0-.16-.27-.1-.3,0A57,57,0,0,1,180,449.81.26.26,0,0,0,180.4,450.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44,451.79c2.62-3.2,4.45-7.85,3.4-12,0-.16-.26-.1-.29,0A57.29,57.29,0,0,1,177,451.53.26.26,0,0,0,177.44,451.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.49,453.51c2.61-3.19,4.45-7.85,3.4-11.95,0-.16-.27-.1-.3,0a56.64,56.64,0,0,1-3.54,11.66A.26.26,0,0,0,174.49,453.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.53,455.24c2.62-3.2,4.45-7.85,3.4-12,0-.16-.26-.1-.29,0A56.94,56.94,0,0,1,171.09,455,.26.26,0,0,0,171.53,455.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.56,416.54c2.87-3.64-2.77-8.1-5.65-4.46S193.69,420.18,196.56,416.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.25,460.41c2.66-.56,3-3.67,2.36-5.8a21.6,21.6,0,0,0-5.93-9.5.11.11,0,0,0-.18,0,.5.5,0,0,0-.72.37c-.23,3.57-.93,7.35-.06,10.88C182.22,458.45,183.74,460.94,186.25,460.41ZM182.53,451c.07-1.76.23-3.5.24-5.26a65.11,65.11,0,0,1,3.34,5.63,23.39,23.39,0,0,1,1.25,2.91c.51,1.55.69,6.87-3.08,4.4C182.2,457.31,182.44,453.08,182.53,451Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.85,436.13c-2.66,2.47-4.17,6-5.93,9.11a.5.5,0,0,0,.39.71.11.11,0,0,0,.13.12,21.67,21.67,0,0,0,10.19-4.66c1.68-1.44,3.13-4.21,1.22-6.14S189.41,434.68,187.85,436.13Zm3.39-.49c4.51,0,1.43,4.35.15,5.36a23.21,23.21,0,0,1-2.64,1.75,63.87,63.87,0,0,1-5.89,2.85c1-1.47,1.79-3,2.7-4.52C186.64,439.29,188.76,435.63,191.24,435.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.09,403,268,401s37.36-10.83,59-5.16c24.76,6.5,28.25,35.42,3.08,47-24.9,11.47-134.51,7.24-134.51,7.24l23.5-34.8s36.09-8.47,67.68-6.75l-44.73,5.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.35,410.39c3.85-.63,7.74-.95,11.63-1.31s7.84-.64,11.76-.89c7.83-.49,15.69-.65,23.53-.36l2.2.12a3.88,3.88,0,0,1,.49-.11c.37-.08.75-.17,1.13-.24.71-.12,1.43-.2,2.14-.3,1.49-.2,3-.32,4.46-.57a.07.07,0,0,1,0,.14c-1.49.3-3,.7-4.45,1l-1.29.25c2.87.21,5.74.49,8.6.81.09,0,.09.15,0,.14-3.9-.31-7.83-.42-11.74-.43s-7.77,0-11.65.13c-7.86.28-15.71.82-23.54,1.48-4.39.37-8.8.82-13.21.91C242,411.16,241.92,410.46,242.35,410.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.71,449.28c1.44-2.21,2.69-4.58,4-6.87l4-6.88c2.67-4.57,12.25-19.94,13.19-21,.06-.07.18,0,.15.09-.47,1.2-6.46,11.38-7.83,13.65-2.76,4.54-5.65,9-8.5,13.46-.81,1.28-1.65,2.54-2.48,3.82s-1.69,2.52-2.46,3.82C206.78,449.44,206.65,449.36,206.71,449.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.39,463.32c-.63-2.11-36.4-52.07-38.91-53.09-.28-.13-17.17,11.23-17.17,11.23-.7.89-32-6.6-32-6.6l-1.33,38,57.41.31s7.63,4.76,14.62,8.66h0a82.52,82.52,0,0,0,9.21,4.77C330.07,467.4,336,465.42,335.39,463.32Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.22,466.58a81.81,81.81,0,0,1-9.2-4.77h0c-7-3.9-14.62-8.67-14.62-8.67l-12.77-.06-19.14-32.79c4.37.9,7.63,1.45,7.86,1.16,0,0,16.87-11.35,17.16-11.21,2.51,1,38.27,51,38.91,53.08S330.07,467.4,327.22,466.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.73,463.39c-.67-2.16-36.61-52.1-39.18-53.14-1-.4-9.21,4.39-17.24,11.21l23.21,32.16S324.39,466,327.33,466.8,336.4,465.56,335.73,463.39Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.22,464.11c-6.23-8.22-30.58-42-36.12-50.58,0-.07,0-.1.06,0,6.35,8,30.42,42,36.19,50.51C333.47,464.19,333.35,464.29,333.22,464.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.23,464.88a8.26,8.26,0,0,1-1.56-6.48,8,8,0,0,1,3.12-5.09s.12.06.07.1a9.58,9.58,0,0,0-1.53,11.39C323.37,464.87,323.28,464.94,323.23,464.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.25,455.64c-2.46-3.31-4.07-8.05-2.83-12.1.05-.16.27-.09.29,0a57.3,57.3,0,0,0,3,11.81A.26.26,0,0,1,305.25,455.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.12,457.5c-2.46-3.31-4.07-8.05-2.83-12.1,0-.16.27-.09.29.05a57.55,57.55,0,0,0,3,11.82A.26.26,0,0,1,308.12,457.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,459.37c-2.46-3.32-4.07-8.06-2.83-12.11,0-.16.27-.09.29.05a57.55,57.55,0,0,0,3,11.82A.26.26,0,0,1,311,459.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.86,461.23c-2.46-3.32-4.07-8.06-2.83-12.11.05-.16.27-.09.29.05a57.55,57.55,0,0,0,3,11.82A.26.26,0,0,1,313.86,461.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.69,421.39c-2.7-3.77,3.15-8,5.85-4.19S293.39,425.16,290.69,421.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.63,461.9c1-3.49.52-7.3.45-10.87a.5.5,0,0,0-.7-.41.11.11,0,0,0-.17,0,21.7,21.7,0,0,0-6.38,9.21c-.71,2.1-.54,5.22,2.08,5.91S303,463.93,303.63,461.9ZM301,464.05c-3.89,2.29-3.45-3-2.87-4.54a22,22,0,0,1,1.38-2.85c1.06-1.92,2.37-3.66,3.6-5.46-.07,1.76,0,3.51,0,5.26C303.06,458.56,303.11,462.79,301,464.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.51,440.22c-2,1.84-.68,4.68.93,6.19a21.6,21.6,0,0,0,10,5.14.1.1,0,0,0,.13-.11.5.5,0,0,0,.43-.69c-1.62-3.18-2.95-6.79-5.5-9.39C297,439.85,294.4,438.49,292.51,440.22Zm8,6.2c.83,1.55,1.59,3.13,2.48,4.65-1.94-1-3.91-1.93-5.75-3.13a24.66,24.66,0,0,1-2.56-1.87c-1.23-1.08-4.1-5.55.41-5.36C297.58,440.82,299.53,444.58,300.52,446.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.86,403.16l-25.75-.68s-26.59-13.67-48.43-9c-25,5.32-29,36.48-10.74,48C184.12,456.09,289,456.17,289,456.17l-21.64-39s-34.67-8.26-66.31-8l44.44,7.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.82,419.68a.71.71,0,0,1,0-.2l0-.16-.09-.38a7.41,7.41,0,0,0-.24-.76c-.09-.25-.19-.49-.3-.74a5.44,5.44,0,0,0-.41-.69s0,0-.06,0l0,0-.06,0-.06,0c-3.81-.81-29.76-5.23-33.62-5.78s-7.8-1-11.71-1.45c-7.79-.86-15.64-1.39-23.49-1.47h-2.2l-.48-.13-1.12-.29c-.71-.15-1.42-.27-2.13-.4-1.47-.27-3-.46-4.43-.78-.08,0-.12.12,0,.14,1.47.37,2.92.84,4.39,1.2l1.28.3c-2.88.08-5.75.23-8.63.41a.07.07,0,1,0,0,.14c3.91-.12,7.84,0,11.75.12s7.76.36,11.63.68c7.83.66,15.65,1.57,23.44,2.6,4.37.57,30.83,5.15,35.23,5.46h.05c0,.1.07.2.12.3s.23.48.35.72.24.46.37.68l.21.32.11.16a1.63,1.63,0,0,1,.11.17C268.72,419.83,268.87,419.77,268.82,419.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.9,453.62c-1.34-2.29-2.47-4.71-3.69-7.06l-3.69-7.07c-2.45-4.69-11.3-20.5-12.18-21.61-.06-.07-.18,0-.15.09.4,1.21,5.91,11.67,7.17,14,2.54,4.67,5.22,9.24,7.85,13.85.75,1.32,1.53,2.62,2.3,3.93s1.57,2.6,2.27,3.94C280.82,453.77,281,453.7,280.9,453.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.39,296.3l4,29.59c.21.88-.3,1.51-1.12,1.42l-14.84-1.7a2.44,2.44,0,0,1-1.89-1.77l-3.94-29.59c-.21-.88.29-1.51,1.12-1.42l14.84,1.7A2.42,2.42,0,0,1,196.39,296.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.63,296.08l4,29.59c.21.88-.29,1.52-1.12,1.42l-14.84-1.7a2.44,2.44,0,0,1-1.89-1.77L176.79,294c-.21-.88.29-1.51,1.12-1.42l14.84,1.71A2.4,2.4,0,0,1,194.63,296.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.41,296.93a1.27,1.27,0,1,0,1.38-1.15A1.27,1.27,0,0,0,190.41,296.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.37,343.35c-10.3,17-31.88,38.1-39.63,38.85-3.72.36-10.41.51-14.84-4.27-9.65-10.44-16.65-29.2-17.39-39.59-.26-3.7,18.22-9.69,20.51-6.46,5.37,7.57,11,21.89,12.12,21.92,4,.12,19.07-10.34,31.34-17.74C246,327.32,243.48,336.57,239.37,343.35Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.06,319.55c2.65-7.17,4.43-8.6,3.45-15.84-.65-4.75,2.11-7.19,5-3.13,4.72,6.64,3.25,16.6,1.74,19.91Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,341.59s-2.2-10.61-.14-18.53c1.43-5.47,5.87-17,22.11-21.67,3.85-1.1,10.11.07,4.48,4.15-4,2.9-7.43,3.52-9.45,5.63,0,0,7.8,2.43,8.75,6.33a74.57,74.57,0,0,1,1.75,10.38,16.92,16.92,0,0,1-1.91.5s.78,3.68-2.4,8.45Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.1,318.06c2.45-1.67,7.7-5.13,13-6.45,5.87-1.48,17.56-2.74,18.61,1.6.76,3.18-3.66,4.06-3.66,4.06s4.94.49,5,3.52c.05,2.76-3.41,3.23-3.41,3.23s3,.82,2.49,3.48c-.55,3.21-6.63,1-10,3.74C191.37,331.86,170.1,318.06,170.1,318.06Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.61,318.06a24.15,24.15,0,0,1,14.33-.89c.12,0,.16.15.05.14a59.26,59.26,0,0,0-14.37.81S183.58,318.08,183.61,318.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.27,323.94c2.32-.8,9.09-1.75,14.36,0,.12,0,.15.15,0,.13a63.84,63.84,0,0,0-14.39,0A0,0,0,0,1,185.27,323.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,362l-21.8-10.75s20.81-13.64,30.5-17.7c10.09-4.23,13.47-1.92,5.21,10S226.38,362,226.38,362Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.1,357.41l-.09.12a44.89,44.89,0,0,0-4-2.2,21.6,21.6,0,0,0-4.12-1.57l-.32-.08-.44-.1a13.08,13.08,0,0,0-5.14-.12,14.9,14.9,0,0,0-4,1.44l-.29-.15a15.68,15.68,0,0,1,4.29-1.52,13.16,13.16,0,0,1,5.23.15l.58.14.32.08a22.74,22.74,0,0,1,4,1.58A44.23,44.23,0,0,1,230.1,357.41Zm13.34-20a18.09,18.09,0,0,0-4.22,3.1,18.65,18.65,0,0,0-3.14,4.2,31.77,31.77,0,0,0-2.18,5,1.07,1.07,0,0,0-.07.19c-.52,1.49-1,3-1.46,4.51.17-.23.35-.46.52-.7.4-1.26.79-2.52,1.23-3.76a1.39,1.39,0,0,1,.06-.19,31.56,31.56,0,0,1,2.14-4.92,17.92,17.92,0,0,1,7.23-7.24l.36-.19.15-.34Zm-9.26,12.36-.08,0-.2,0a13.3,13.3,0,0,0-5,.1,16.84,16.84,0,0,0-4.82,2.05,18.71,18.71,0,0,0-2.25,1.6l-.19.16a19.68,19.68,0,0,0-1.64,1.53,23.43,23.43,0,0,0-2.1,2.58l.22.11a23.58,23.58,0,0,1,2.07-2.51,21,21,0,0,1,1.77-1.63l.19-.16a19.8,19.8,0,0,1,2.07-1.46,16.31,16.31,0,0,1,4.74-2,13,13,0,0,1,4.9-.14l.24,0h.05c.45.08.9.17,1.35.29l.13-.17C235.13,350,234.66,349.9,234.18,349.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.76,357.51a16.38,16.38,0,0,0-1.54-.83l-1.59-.83c-1.07-.57-2.15-1.11-3.23-1.65-2.17-1.08-4.33-2.16-6.52-3.2-.6-.29-1.2-.57-1.81-.84s-1.29-.52-1.93-.81c0,0-.06,0,0,.06.53.29,1,.61,1.57.9s1.08.58,1.63.86l3.25,1.61c2.14,1.05,4.28,2.1,6.44,3.1l1.81.83c.63.29,1.26.62,1.92.86C226.76,357.58,226.79,357.53,226.76,357.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.29,343.53c-8.3,12-13.91,18.46-13.91,18.46l-9.67-4.77,26.87-25.44C246,332.62,245.3,336.31,240.29,343.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,402.9c.89,1.05,60.6.36,60.93,0,.88-1-9.56-52.49-20.05-68.2-3.54-5.3-14.8-6.38-18.73-1.24C225.88,348.22,214.23,402,215,402.9Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.56,364.66s0,0,0,0a18.82,18.82,0,0,1-3.8,2.72,20.37,20.37,0,0,1-4.88,1.88,15.81,15.81,0,0,1-5.22.37,20.26,20.26,0,0,1-5.1-1.14,34.49,34.49,0,0,1-4.76-2.15c-1.69-.92-3.32-1.94-4.93-3l-.26-.17c-1.22-.8-2.42-1.62-3.63-2.43s-2.39-1.62-3.61-2.41l-.24-.15c-1.36-.87-2.74-1.7-4.18-2.44a1,1,0,0,1,.05-.16c1.44.75,2.82,1.58,4.18,2.46l.24.16c1.23.79,2.43,1.62,3.63,2.44s2.41,1.66,3.64,2.46a1.92,1.92,0,0,0,.26.17l.43.29c1.46.94,3,1.84,4.47,2.67a32.59,32.59,0,0,0,4.76,2.12,19.16,19.16,0,0,0,5.07,1.11,15.67,15.67,0,0,0,5.15-.39,20,20,0,0,0,4.82-1.9,17.75,17.75,0,0,0,3.53-2.52.94.94,0,0,0,.18-.17.64.64,0,0,0,.15-.14c0,.05,0,.09,0,.14S267.55,364.61,267.56,364.66Zm-11.05-29a20.13,20.13,0,0,0-3-.49,4.58,4.58,0,0,0-.53,0,2.36,2.36,0,0,0-.38,0,14.82,14.82,0,0,0-4.3.41,19.83,19.83,0,0,0-4.88,1.89,18.09,18.09,0,0,0-4.22,3.1,18.65,18.65,0,0,0-3.14,4.2,31.77,31.77,0,0,0-2.18,5,1.07,1.07,0,0,0-.07.19c-.53,1.51-1,3.05-1.48,4.57-.37,1.18-.76,2.37-1.2,3.54a.58.58,0,0,0-.05.14,24,24,0,0,1-3,5.73,16,16,0,0,1-2.89,3l-.25.2-.56.41a15.44,15.44,0,0,1-1.4.86l-.12.43a18.39,18.39,0,0,0,1.7-1c.27-.19.53-.38.78-.59l.26-.21a16.73,16.73,0,0,0,2.72-2.86,23.89,23.89,0,0,0,3-5.76s0-.08,0-.13c.46-1.19.85-2.41,1.24-3.61.49-1.54,1-3.09,1.49-4.61a1.39,1.39,0,0,1,.06-.19,31.56,31.56,0,0,1,2.14-4.92,17.92,17.92,0,0,1,7.23-7.24,19.41,19.41,0,0,1,4.82-1.89,14.66,14.66,0,0,1,4.07-.45h.38l.7,0a19.42,19.42,0,0,1,3.11.52Zm-1.69-2.24a16.35,16.35,0,0,0-2.2,1.7l-.18.16q-.47.44-.9.9a18.77,18.77,0,0,0-3,4.33,52.74,52.74,0,0,0-3.3,9.92c-.33,1.2-.67,2.4-1.07,3.58a.57.57,0,0,1,0,.14,23.18,23.18,0,0,1-2.78,5.86,16.37,16.37,0,0,1-2.73,3.08.27.27,0,0,1-.08.07c-.24.21-.48.41-.73.6a20.17,20.17,0,0,1-4.51,2.52,13.64,13.64,0,0,1-5.06.9,20.36,20.36,0,0,1-2.7-.24c-.14,0-.27,0-.41-.06q-.84-.14-1.68-.33l-.06.22c.49.11,1,.22,1.49.31l.4.07a20.9,20.9,0,0,0,3,.29,13.78,13.78,0,0,0,5.16-.89A19.64,19.64,0,0,0,238,364c.28-.21.55-.44.81-.67l.08-.07a16.54,16.54,0,0,0,2.71-3.08,23.45,23.45,0,0,0,2.8-5.87s0-.09,0-.14c.41-1.21.75-2.44,1.09-3.66a51.7,51.7,0,0,1,3.27-9.87,18.59,18.59,0,0,1,2.91-4.28,12.11,12.11,0,0,1,1.08-1.07.8.8,0,0,1,.18-.15,15.6,15.6,0,0,1,2-1.56A1.29,1.29,0,0,0,254.82,333.46Zm12.74,31.2c0-.05,0-.1,0-.15h-.33a19.71,19.71,0,0,1-5.11-.89,34.76,34.76,0,0,1-4.84-1.91q-2.34-1.15-4.59-2.48c-1.5-.89-3-1.81-4.45-2.74-1.23-.77-2.47-1.54-3.73-2.28a2.26,2.26,0,0,0-.26-.16,50.72,50.72,0,0,0-5.12-2.67,21.27,21.27,0,0,0-4.91-1.56l-.08,0-.2,0a13.24,13.24,0,0,0-4.86.07c0,.09-.07.17-.1.26a13,13,0,0,1,4.89-.14l.24,0h.05a21.76,21.76,0,0,1,4.9,1.53,50.05,50.05,0,0,1,5.15,2.65l.26.16c1.25.73,2.48,1.48,3.71,2.24,3,1.82,5.91,3.68,9.05,5.22a33.42,33.42,0,0,0,4.85,1.95,19.75,19.75,0,0,0,5.11.92h.42A0,0,0,0,0,267.56,364.66Zm3.91,15a18.48,18.48,0,0,0-4.51,2.31,52.17,52.17,0,0,0-7.68,7.09c-.86.89-1.74,1.78-2.66,2.63l-.11.1a23.58,23.58,0,0,1-5.27,3.79,16.32,16.32,0,0,1-4.9,1.57l-.12,0a20.32,20.32,0,0,1-5.05,0,13.08,13.08,0,0,1-3.91-1.17l-.34-.16-.61-.32a23.68,23.68,0,0,1-4.16-3.1c-2.22-2-4.24-4.22-6.53-6.16l-.16-.14c-.32-.27-.65-.53-1-.79a20,20,0,0,0-4.49-2.67l-.65-.25-.13-.05s0,.05,0,.08l0,0,.72.29a20.35,20.35,0,0,1,4.44,2.7l.94.76.16.14c2.27,2,4.29,4.2,6.51,6.24a23.85,23.85,0,0,0,4.18,3.15l.45.24.34.17a13.28,13.28,0,0,0,4.16,1.31,19.64,19.64,0,0,0,5.25,0h0l.11,0a16.76,16.76,0,0,0,4.87-1.59,23.59,23.59,0,0,0,5.28-3.79l.11-.1c.94-.87,1.84-1.78,2.71-2.69a52.5,52.5,0,0,1,7.63-7.06,18.74,18.74,0,0,1,4.43-2.27A2.68,2.68,0,0,0,271.47,379.62Zm-10,20.63c-.89-1.5-1.73-3-2.58-4.54-.71-1.27-1.42-2.55-2.16-3.8l-.15-.26a49.8,49.8,0,0,0-3.21-4.82,21,21,0,0,0-3-3.29,1.2,1.2,0,0,0-.21-.19l-.36-.31a13.25,13.25,0,0,0-4.61-2.46,16.66,16.66,0,0,0-5.21-.53,19.23,19.23,0,0,0-5.16.92,17.34,17.34,0,0,0-1.7.63,1.08,1.08,0,0,0-.28.11,37.5,37.5,0,0,0-7.2,4.24l-.19.14-.13.09a76.58,76.58,0,0,1-8.31,5.61l-.05,0a.65.65,0,0,1,0,.13.17.17,0,0,1,0,.07l.05,0,.12-.06a78.18,78.18,0,0,0,8.4-5.61l.13-.09.15-.11a37.07,37.07,0,0,1,7.39-4.27l.27-.11c.48-.19,1-.37,1.47-.52a20.17,20.17,0,0,1,5.1-.91,16.37,16.37,0,0,1,5.13.49,13,13,0,0,1,4.55,2.4,4.38,4.38,0,0,1,.34.29,1.24,1.24,0,0,1,.22.19,20.9,20.9,0,0,1,3,3.26,50.47,50.47,0,0,1,3.23,4.81l.15.26c.74,1.24,1.46,2.5,2.17,3.75,1.43,2.52,2.84,5.06,4.42,7.49h.14C262.74,402.26,262.11,401.26,261.51,400.25Zm-13.51-.5c-.51-.78-1-1.57-1.49-2.36a2.61,2.61,0,0,1-.17-.28c-.38-.6-.74-1.19-1.11-1.79-.77-1.24-1.53-2.48-2.32-3.7l-.17-.25a49.78,49.78,0,0,0-3.4-4.68,20.91,20.91,0,0,0-3.77-3.63,14.65,14.65,0,0,0-2.14-1.32l-.3-.14a12.24,12.24,0,0,0-2.27-.8,16.7,16.7,0,0,0-5.23-.31,19.09,19.09,0,0,0-5.11,1.13q-.65.24-1.26.51l0,.2s0,.05,0,.08v0l0,0a.27.27,0,0,1,.11-.05c.42-.19.84-.36,1.27-.51a19.76,19.76,0,0,1,5-1.12,16.18,16.18,0,0,1,5.15.27,12.25,12.25,0,0,1,2,.69l.31.14a14,14,0,0,1,2.29,1.37,21.19,21.19,0,0,1,3.75,3.58,51.14,51.14,0,0,1,3.45,4.67c0,.08.1.17.16.25.79,1.21,1.56,2.44,2.32,3.66l1.09,1.75.18.28c1.27,2,2.57,4.06,4,6h.14Q249.21,401.62,248,399.75ZM271.32,379a15,15,0,0,0-3.74-1.2,20,20,0,0,0-5.23-.25,18,18,0,0,0-5.12,1.12,18.67,18.67,0,0,0-4.57,2.56,26.74,26.74,0,0,0-2.49,2.14l-.15.14c-1.68,1.62-3.19,3.4-4.73,5.14-.83.93-1.67,1.86-2.55,2.74l-.09.1a23.8,23.8,0,0,1-5.11,4l-.62.33-.29.14a16,16,0,0,1-3.92,1.31,19.83,19.83,0,0,1-5.16.25,13.35,13.35,0,0,1-4.93-1.44,23.53,23.53,0,0,1-4.29-2.92c-.46-.38-.91-.77-1.36-1.16l0,0a.17.17,0,0,1,0,.07.85.85,0,0,1,0,.17l1.31,1.13a23.8,23.8,0,0,0,4.31,3,13.77,13.77,0,0,0,5,1.5,19.58,19.58,0,0,0,5.24-.24,16.51,16.51,0,0,0,4.21-1.44l.29-.15c.15-.07.29-.15.43-.23a23.55,23.55,0,0,0,5.12-4l.1-.1c.9-.91,1.76-1.85,2.59-2.8,1.55-1.75,3.07-3.54,4.74-5.14a.92.92,0,0,1,.14-.14,27.14,27.14,0,0,1,2.45-2.1,18.35,18.35,0,0,1,4.5-2.54,18.09,18.09,0,0,1,5-1.14,19.9,19.9,0,0,1,5.17.22,14.75,14.75,0,0,1,3.83,1.22A1.74,1.74,0,0,0,271.32,379Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.19,337.61c24.75,21,46.59,49,43.93,57.41-2.81,8.91-21.33,18-37.27,19.09-3.27.23-11.87-24.13-8.49-25,2.64-.7,14.6-3.34,16.1-4.86,1-1.07-16.44-25.44-21.58-39.2C249.51,330.64,255.56,332,262.19,337.61Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.08,388.77s-9.94.4-16.44,1c-3.62.32-9.78,1.42-12.33,2.87-3.82,2.17-18.42,13.69-15.7,17.28,2.46,3.26,6.74-1.41,6.74-1.41s-5.16,4.67-1.73,7.15,8.45-4.12,8.45-4.12-5.82,4.57-1.9,6.86c3.4,2,10-5,10-5s-6.64,4.12-3.36,6.51c3.63,2.64,14.8-6.63,14.8-6.63,8.41,1.46,13.66,1.19,19.72-.13C276.41,412.88,267.08,388.77,267.08,388.77Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.49,413.07c.41-.5.84-1,1.25-1.5a32.44,32.44,0,0,1,2.55-2.82c.89-.86,1.82-1.67,2.78-2.45s2.11-1.56,3.1-2.41c.08-.07.17,0,.09.11a33.6,33.6,0,0,0-2.81,2.66c-.9.89-1.79,1.79-2.67,2.69s-1.79,1.7-2.68,2.56c-.45.42-.87.87-1.3,1.32a11.17,11.17,0,0,1-1.24,1.24c-.05,0-.1,0-.08-.07A7.64,7.64,0,0,1,234.49,413.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.3,409.48a50.5,50.5,0,0,1,4.6-5.36,35.05,35.05,0,0,1,5.5-4.44c.07,0,.15.05.09.11-1.67,1.67-3.38,3.31-5.08,4.95-.83.8-4.5,4.56-4.93,4.91C228.37,409.73,228.24,409.58,228.3,409.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.22,416.61a49.7,49.7,0,0,1,4.42-5,45.85,45.85,0,0,1,5.56-3.89c.07,0,.16.06.09.11-1.75,1.43-3.51,2.83-5.19,4.35-.82.74-3.91,3.87-4.75,4.51A.09.09,0,0,1,240.22,416.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,365.92l23.53-6.12s-17.63-17.57-26.29-23.5c-9-6.19-12.81-4.6-7.13,8.73S264,365.92,264,365.92Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.31,340.21q-1.43-.9-2.91-1.71a33.4,33.4,0,0,0-4.76-2.16,19.89,19.89,0,0,0-5.11-1.13,4.58,4.58,0,0,0-.53,0,2.36,2.36,0,0,0-.38,0c-.39,0-.79,0-1.18,0a1.15,1.15,0,0,0,0,.19c.34,0,.68,0,1,0h.38l.7,0a20.08,20.08,0,0,1,5.07,1.11,34.75,34.75,0,0,1,4.75,2.12c1.19.65,2.36,1.34,3.51,2Zm-11-7.09a17.4,17.4,0,0,0-2.72,2l-.18.16q-.47.44-.9.9l-.09.1c0,.12,0,.25,0,.38a3.31,3.31,0,0,1,.25-.3,12.11,12.11,0,0,1,1.08-1.07.8.8,0,0,1,.18-.15,17.2,17.2,0,0,1,2.62-2Zm27.89,22.48a17.53,17.53,0,0,1-6.18,6.2,17.93,17.93,0,0,1-3,1.51l1.37-.35c.61-.29,1.21-.61,1.79-1a18.48,18.48,0,0,0,4.09-3.28,17.69,17.69,0,0,0,2.17-2.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.49,348.29c-.24.68-.46,1.36-.68,2a52.18,52.18,0,0,1-3.72,9.76,18.43,18.43,0,0,1-3.14,4.2,2.4,2.4,0,0,1-.24.22,15.55,15.55,0,0,0,2.05-.1l-1,.26c-.4,0-.81,0-1.22,0a6.2,6.2,0,0,1-.48.43l-.59.16a6.44,6.44,0,0,0,.69-.6A20.33,20.33,0,0,1,263,364a1.51,1.51,0,0,0-.09-.18,19.72,19.72,0,0,0,4.31.66h.14a5.36,5.36,0,0,0,.43-.4,18.35,18.35,0,0,0,3.08-4.14,52.07,52.07,0,0,0,3.7-9.72c.23-.72.46-1.45.72-2.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.53,361.46c.54-.21,1.11-.35,1.67-.51l1.73-.49c1.16-.34,2.33-.65,3.5-1,2.34-.61,4.67-1.24,7-1.82l1.94-.45c.69-.15,1.38-.25,2.06-.4a0,0,0,0,1,0,.06c-.58.17-1.14.39-1.71.57L279,358q-1.74.48-3.51.93c-2.3.59-4.61,1.19-6.93,1.73l-1.94.45c-.68.16-1.36.35-2.05.45C264.51,361.52,264.49,361.47,264.53,361.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.85,351.58s0-.09.07-.05a17.12,17.12,0,0,1,1.7,2.26c-.17-.4-.36-.79-.54-1.18-.56-1.28-1.11-2.57-1.68-3.84,0,0,0-.08.07,0,1.15,2.16,2.38,4.27,3.46,6.46s2.16,4.37,3.2,6.58c.58,1.21,1.2,2.76,1.77,4,.71-.08,1.57-.33,2.33-.43.07,0,.07.1,0,.11-.78.21-1.66.6-2.5.74-.1,0-4-7.77-5.73-11.53C257.26,353.63,256.53,352.62,255.85,351.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.62,342.94c3.37,1,9.52-3.9,12.07-8,.17-.28-.1-3.36-.26-7.12-.09-2.28-.13-4.82,0-7.14,0-.48-14.76,2.73-14.76,2.73a37.14,37.14,0,0,1,.91,9,4.62,4.62,0,0,1-.15.94l0,.16C238,335.3,237.37,342,240.62,342.94Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.53,320.69c-.89,3.89-3.86,13.24-11.64,13a8.4,8.4,0,0,1-1.49-.16.76.76,0,0,1,0-.16,6.82,6.82,0,0,0,.16-.94,37.38,37.38,0,0,0-.92-9S248.34,321.09,251.53,320.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.36,303.53c1.34,5.24-2.09,20-5.92,23.19-5.56,4.58-14.3,4.63-18.1-2-3.68-6.39,1.13-25.6,5.38-28.43C242,292.15,252.39,295.79,254.36,303.53Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.36,303.53c1.34,5.24-2.09,20-5.92,23.19-5.56,4.58-14.3,4.63-18.1-2-3.68-6.39,1.13-25.6,5.38-28.43C242,292.15,252.39,295.79,254.36,303.53Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.09,312.14s.07.07.06.11c-.26,1-.39,2.16.44,2.7,0,0,0,.07,0,.05C238.5,314.6,238.69,313,239.09,312.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.22,311.3c1.63.24,1,3.49-.49,3.27S238.85,311.1,240.22,311.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.46,311.12s-.09,0-.1.08c-.15,1-.5,2.14-1.47,2.31,0,0,0,.05,0,.05C233,313.62,233.47,312.11,233.46,311.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.75,309.91c-1.59-.43-2.32,2.79-.84,3.19S234.09,310.26,232.75,309.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.18,308.74c-.45-.12-.84-.3-1.27-.46a2.21,2.21,0,0,1-1.22-.72.7.7,0,0,1,.12-.84,1.74,1.74,0,0,1,1.75-.17,2.54,2.54,0,0,1,1.46,1.11A.75.75,0,0,1,242.18,308.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.74,308.2a10.24,10.24,0,0,0,1.36-.09,2.18,2.18,0,0,0,1.36-.36.68.68,0,0,0,.11-.84,1.71,1.71,0,0,0-1.63-.64,2.57,2.57,0,0,0-1.71.67A.74.74,0,0,0,231.74,308.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,321.8c-.28.19-.58.47-.95.43a2.68,2.68,0,0,1-1-.45s-.07,0,0,0a1.38,1.38,0,0,0,1.17.79,1.11,1.11,0,0,0,1-.75C239.15,321.81,239.07,321.77,239,321.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.54,318.59a3.51,3.51,0,0,1-2.57,1.1,4.43,4.43,0,0,1-1.25-.17l-.23-.07-.21-.08a.25.25,0,0,1-.16-.26h0a.38.38,0,0,1,0-.1h0l0-.09c.12-.77.42-1.94.42-1.94-.31.09-1.88.47-1.78.07a52.36,52.36,0,0,1,3.26-10.12c0-.1.21,0,.18.06-.67,3.22-1.89,6.29-2.61,9.51a6.15,6.15,0,0,1,1.7-.19c.11.06-.6,2.24-.63,2.6v0a4.82,4.82,0,0,0,3.75-.44C238.54,318.44,238.61,318.52,238.54,318.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.25,319.21a4.18,4.18,0,0,0,1.4,1.56,1.84,1.84,0,0,0,1.09.28c.85-.06,1-.8,1-1.45a4.28,4.28,0,0,0-.18-1A5.35,5.35,0,0,1,235.25,319.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.65,320.77a1.84,1.84,0,0,0,1.09.28c.85-.06,1-.8,1-1.45A1.9,1.9,0,0,0,236.65,320.77Z",
    style: {
      fill: "#ff97b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.76,314.46c-.95-.39-2.5-4.28-3.18-5.84s.43-8.78.73-10.4a11,11,0,0,1,3.11,5.21C255,305.81,254.68,310.12,253.76,314.46Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.72,301.14a5.21,5.21,0,0,0,4.31,2.69,5.3,5.3,0,0,0,4.65-2.28,0,0,0,0,1,.07.05,5.27,5.27,0,0,1-4.73,2.66,5.38,5.38,0,0,1-4.41-3.06C237.58,301.13,237.68,301.07,237.72,301.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.61,289.62a8.25,8.25,0,0,1,6,5.12,5.85,5.85,0,0,1-.21,3.84c0,.05-.13,0-.11,0a6.42,6.42,0,0,0-1.8-6.29,8.26,8.26,0,0,0-7-2.34,5.23,5.23,0,0,0-3.21,1.64c-.08.09-.28,0-.21-.12C240.25,289.76,242.94,289,245.61,289.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.1,292.5a6.7,6.7,0,0,1,3.5-2.94c2.05-.75,4.07-.16,6.06.47.06,0,0,.1,0,.08a9.16,9.16,0,0,0-5.22-.47,6.5,6.5,0,0,0-3.61,2.51,6.37,6.37,0,0,0,1,8.29,6.49,6.49,0,0,0,4.9,1.55c.07,0,.1.09,0,.1a6.51,6.51,0,0,1-6.63-9.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.79,306.57s3.88-4.73,2.15-8.27c-1-2-5.45-2.67-5.45-2.67a8.11,8.11,0,0,0-4.4-4.4c-3.53-1.59-8.37-.32-8.37-.32s-3.11-2.72-6.78-1.5c-5.12,1.7-5.95,8.81-1.78,12,2.92,2.24,7.91.25,7.91.25.41.14,4.22,3.63,8.28.42,0,0,2.19,2.91,4.91,1.73A3.93,3.93,0,0,0,254.79,306.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.6,315.54s3.7-4.59,5.8-3.24-.89,8.17-3.53,8.95a2.61,2.61,0,0,1-3.4-1.64Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.49,314.23a0,0,0,0,1,0,.07c-1.85.61-2.91,2.22-3.69,3.9A1.46,1.46,0,0,1,254,318s0,.11-.06.1a1.59,1.59,0,0,0-1.8.44,7.61,7.61,0,0,0-.95,1.37c-.09.16-.38.05-.3-.13v0C251,317.39,253,314.3,255.49,314.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.43,336.06a66.54,66.54,0,0,1-5.2,5.55,11.12,11.12,0,0,1-6.27,3.22c-2.31.19-4.61-.31-5.44-3.14a17,17,0,0,1-.1-7.42.09.09,0,1,0-.17,0c-.56,3.69-1.17,9.42,2.18,10.73,3.75,1.46,7.45-.44,10.12-3a35.16,35.16,0,0,0,4.95-5.85S254.47,336,254.43,336.06Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMedia);
export default __webpack_public_path__ + "static/media/social-media.c608b15fea19a0eedf60d063866e72e8.svg";
export { ForwardRef as ReactComponent };